import { parseUnits } from '@ethersproject/units';
import { useMutation } from '@tanstack/react-query';
import { useGardenDeposit } from '@ui/hooks/useGardenDeposit';
import usePendingVno from '@ui/hooks/usePendingVno';
import { gardenTokenDict } from '@ui/utils/garden';
import type { EthersError } from '@veno-app/sdk';

import { useGardenHarvestDrawer } from './useGardenHarvestDrawer';

export enum GARDEN_HARVEST_STEP {
  default,
  confirming,
  success,
  failed,
}

export const useGardenHarvest = () => {
  const coinMode = useGardenHarvestDrawer((s) => s.coinMode);
  const setStep = useGardenHarvestDrawer((s) => s.setStep);
  const vaultType = useGardenHarvestDrawer((s) => s.vaultType);
  const gardenType = useGardenHarvestDrawer((s) => s.gardenType);
  const setHarvestAmount = useGardenHarvestDrawer((s) => s.setHarvestAmount);

  const { pendingVno } = usePendingVno(gardenType);

  const { mutateAsync: doGardenDeposit } = useGardenDeposit();

  return useMutation(async () => {
    if (!vaultType || !gardenType || !pendingVno) {
      return null;
    }

    setHarvestAmount(pendingVno);
    setStep(GARDEN_HARVEST_STEP.confirming);

    try {
      await doGardenDeposit({
        gardenType,
        vaultType,
        // deposit 0 amount to trigger harvest
        amount: parseUnits('0', gardenTokenDict[coinMode][gardenType].decimals),
      });

      setStep(GARDEN_HARVEST_STEP.success);
    } catch (err) {
      useGardenHarvestDrawer.setState({
        error: err as EthersError,
      });

      setStep(GARDEN_HARVEST_STEP.failed);

      return null;
    }
  });
};
